import { withNamespaces } from "react-i18next";
import React, { memo, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useLocation, useHistory } from "react-router-dom";
// styles
import "./style.scss";
// components
import Tabs from "./tabs";

// Contents
import DataProtectionHardwareList from "src/modules/data-protection/pages/hardware/list";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/page-header";
import PageBody from "../../components/page-body";
import PageContent from "../../components/page-content";
import Navigator from "../../components/navigator";
import DataProtectionHardwareService from "../../apis/DataProtectionHardwareService";
import { useQuery } from "@tanstack/react-query";

const DataProtectionHardwareMainPage = (props) => {
  const [assetId, setAssetId] = useState(null);
  const history = useHistory();
  const location = useLocation();

  const [detailPage, setDetailPage] = useState(null);

  const [totalCount, setTotalCount] = useState(0);
  const [deletedCount, setDeletedCount] = useState(0);

  const handleFetchCount = useQuery({
    queryKey: ["report-count"],
    queryFn: async () => {
      const service = DataProtectionHardwareService.getInstance();
      return await service.getCount();
      }
  });

  useEffect(() => {
    const counts = handleFetchCount?.data?.data;
    setTotalCount(counts?.all);
    setDeletedCount(counts?.deleted);
  }, [handleFetchCount.data]);

  const [navigatorOptions, setNavigatorOptions] = useState({
    enable: true,
    backButtonOptions: {
      //enable: true,
      onClick: () => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete("page");
        history.push(`/admin/data-protection/reports`);
      },
    },
    breadCrumbs: [
      {
        title: "Hardware Assets",
        link: `/admin/data-protection/hardwares?tab=all-hardware-assets`,
      },
    ],
  });


  const { t } = props;

  const renderContent = () => {
    const searchParams = new URLSearchParams(location.search);

    let result = null;

    switch (searchParams.get("tab")) {
      case "all-hardware-assets":
        result = <DataProtectionHardwareList setAssetId={setAssetId} />;
        break;

      case "deletion-protocol":
        result = <DataProtectionHardwareList setAssetId={setAssetId} />;
        break;
      default:
        break;
    }

    return (
      <React.Fragment>
        <Tabs t={t} totalCount={totalCount} deletedCount={deletedCount} />

        {result}
      </React.Fragment>
    );
  };

  useEffect(() => {
    if (!new URLSearchParams(location.search).get("page")) {
      setDetailPage(null);
    }
  }, [location.search]);

  return (
    <PageContent classNames="data-protection-software-details-page software-details-page">
      <Container fluid>
        {/* page header */}
        <Row>
          {navigatorOptions.enable && (
            <Col lg="12" className="mb-4">
              <Navigator
                backButtonOptions={(props) => {
                  return {
                    ...props,
                    ...navigatorOptions.backButtonOptions,
                  };
                }}
                breadCrumbs={navigatorOptions.breadCrumbs}
              />
            </Col>
          )}
        </Row>

        {/* page body */}
        <PageBody classNames="p-0">
          <div className="details-content-wrapper">{renderContent()}</div>
        </PageBody>
      </Container>
    </PageContent>
  );
};

export default withNamespaces()(
  withRouter(memo(DataProtectionHardwareMainPage))
);
